<div class="modal-backdrop fade show"></div>
<div class="modal fade show d-block" tabindex="-1">
  <div class="modal-dialog modal-xl modal-dialog-scrollable">
    <div class="modal-content">
      <div class="modal-header">
        <span class="fs-3 fw-700">{{ question()?.id ? 'Editar' : 'Nueva' }} {{ type() === 'question' ? 'Pregunta' : 'Subpregunta' }}</span>
      </div>
      <div class="modal-body" [formGroup]="form">
        @if (hasHistory) {
        <div class="alert alert-warning py-2 small">Esta pregunta tiene respuestas registradas: el criterio y el tipo de respuesta no se pueden modificar.</div>
        }
        <div class="row mb-3">
          <label class="form-label col-form-label col-md-3">Criterio</label>
          <div class="col-md-7">
            <input type="text" class="form-control" formControlName="title" [readonly]="hasHistory" />
          </div>
        </div>

        <div class="row mb-3">
          <label class="form-label col-form-label col-md-3">Texto de ayuda</label>
          <div class="col-md-7">
            <textarea rows="2" class="form-control" formControlName="tooltip" placeholder="Texto que se muestra en el tooltip de ayuda"></textarea>
          </div>
        </div>

        @if (type() === 'question') {
        <div class="row mb-3">
          <label class="form-label col-form-label col-md-3">¿Tendrá subpreguntas?</label>
          <div class="col-md-7">
            <div class="form-check form-switch">
              <input class="form-check-input" type="checkbox" role="switch" id="hasSubQ"
                formControlName="hasSubquestions"
                [attr.disabled]="hasHistory ? true : null"
                (change)="onSubSwitchChange($event)">
              <label class="form-check-label" for="hasSubQ">{{ isParentMode ? 'Sí' : 'No' }}</label>
            </div>
            @if (hasHistory) {
            <span class="text-muted small">Bloqueado: tiene periodos con respuestas registradas.</span>
            } @else if (isParentMode) {
            <span class="text-muted small">Solo se guarda criterio y ayuda. El puntaje será la suma de sus subpreguntas.</span>
            }
          </div>
        </div>
        }

        @if (!isParentMode) {
        <div class="row mb-3">
          <label class="form-label col-form-label col-md-3">Tipo de respuesta</label>
          <div class="col-md-7">
            @if (hasHistory) {
            <span class="form-control bg-light">{{typeName}}</span>
            } @else if (questionTypes.length === 1) {
            <span class="form-control bg-light">{{questionTypes[0].label}}</span>
            }@else {
            <select class="form-select" formControlName="typeId">
              <option value="" disabled>Seleccione tipo...</option>
              @for(t of questionTypes; track t.id){
              <option [value]="t.id">{{t.label}}</option>
              }
            </select>
            }
          </div>
        </div>

        <div class="row mb-3">
          <label class="form-label col-form-label col-md-3">Puntaje</label>
          <div class="col-md-7">
            <input type="number" class="form-control" min="1" placeholder="1" formControlName="score" />
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-md-7 offset-md-3">
            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="evidenceRequiredQ" formControlName="evidenceRequired">
              <label class="form-check-label" for="evidenceRequiredQ">Requiere evidencia (50% responder + 50% evidencia)</label>
            </div>
          </div>
        </div>

        @if (showEvidenceSelectors) {
        <div class="row mb-3">
          <label class="form-label col-form-label col-md-3">Evidencia para Sí</label>
          <div class="col-md-7">
            <select class="form-select" formControlName="evidenceTrue">
              @for(o of evidenceOptions; track o.value){
              <option [value]="o.value">{{o.label}}</option>
              }
            </select>
          </div>
        </div>
        <div class="row mb-3">
          <label class="form-label col-form-label col-md-3">Evidencia para No</label>
          <div class="col-md-7">
            <select class="form-select" formControlName="evidenceFalse">
              @for(o of evidenceOptions; track o.value){
              <option [value]="o.value">{{o.label}}</option>
              }
            </select>
          </div>
        </div>
        }

        @if (showSingleEvidenceSelector) {
        <div class="row mb-3">
          <label class="form-label col-form-label col-md-3">Tipo de evidencia</label>
          <div class="col-md-7">
            <select class="form-select" formControlName="evidenceType">
              @for(o of evidenceOptions; track o.value){
              <option [value]="o.value">{{o.label}}</option>
              }
            </select>
          </div>
        </div>
        }

        @if (isAnnual) {
        <div class="row mb-3">
          <label class="form-label col-form-label col-md-3">Tipo de meta</label>
          <div class="col-md-7">
            <select class="form-select" formControlName="goalType">
              <option value="general">General</option>
              <option value="personal">Personal</option>
            </select>
          </div>
        </div>
        @if (form.value.goalType === 'personal') {
        <div class="row mb-3">
          <div class="col-md-7 offset-md-3">
            <span class="text-muted small">El valor de la meta se define por entidad en Administración → Metas.</span>
          </div>
        </div>
        } @else {
        <div class="row mb-3">
          <label class="form-label col-form-label col-md-3">Valor de meta</label>
          <div class="col-md-7">
            <input type="number" class="form-control" step="any" placeholder="Ej: 100" formControlName="goalValue" />
            <span class="text-muted small">Número a alcanzar en el año (usado en cálculo anual).</span>
          </div>
        </div>
        }
        }

        @if (isAnnual || !evaluateAllMonths) {
        <div class="row mb-3">
          <label class="form-label col-form-label col-md-3">{{ isAnnual ? 'Fecha vencimiento' : 'Fecha límite' }}</label>
          <div class="col-md-7">
            <input type="date" class="form-control" formControlName="deadline" />
          </div>
        </div>
        }

        <div class="row mb-3">
          <label class="form-label col-form-label col-md-3">Periodicidad</label>
          <div class="col-md-7">
            @if (evaluateAllMonths) {
            <span class="text-muted small d-block mb-2">El módulo evalúa todas las preguntas cada mes.</span>
            }
            <div class="form-check form-switch mb-2">
              <input class="form-check-input" type="checkbox" role="switch" id="monthlyQ"
                [checked]="isMonthly"
                (change)="onMonthlyChange($event)">
              <label class="form-check-label" for="monthlyQ">Mensual</label>
            </div>
            @if(form.value.months !== null){
            <span class="text-muted small d-block mb-1">Seleccione los meses que aplica:</span>
            }
            <div [class.d-none]="form.value.months === null" style="display:grid;grid-template-columns:repeat(6,auto);gap:0.25rem 0.75rem">
              @for(m of monthsList; track $index; let i = $index){
              <div style="display:inline-flex;align-items:center;gap:0.25rem;white-space:nowrap;cursor:pointer;user-select:none"
                (click)="toggleMonth(i + 1)">
                <input type="checkbox" class="form-check-input"
                  [checked]="isMonthSelected(i + 1)">
                <span class="ms-1">{{m}}</span>
              </div>
              }
            </div>
          </div>
        </div>
        }
      </div>
      <div class="modal-footer">
        <button class="btn btn-danger" (click)="close.emit()">Cerrar</button>
        <button class="btn btn-primary" (click)="onSave()">Guardar</button>
      </div>
    </div>
  </div>
</div>